import { constants } from './constants'

type CookieTree = DeepUndefinable<typeof constants.cookies>
type CookieBranch = {
  [key: string]: string | CookieBranch
}

// Following lines are taken from https://github.com/krzkaczor/ts-essentials
type Primitive = string | number | boolean | bigint | symbol | undefined | null
// eslint-disable-next-line @typescript-eslint/ban-types
type Builtin = Primitive | Function | Date | Error | RegExp

export type DeepUndefinable<T> = T extends Builtin
  ? T | undefined
  : T extends Map<infer K, infer V>
  ? Map<DeepUndefinable<K>, DeepUndefinable<V>>
  : T extends WeakMap<infer K, infer V>
  ? WeakMap<DeepUndefinableNonUndefined<K>, DeepUndefinable<V>>
  : T extends Set<infer U>
  ? Set<DeepUndefinable<U>>
  : T extends WeakSet<infer U>
  ? WeakSet<DeepUndefinableNonUndefined<U>>
  : T extends Array<infer U>
  ? Promise<DeepUndefinable<U>>
  : T extends object
  ? { [K in keyof T]: DeepUndefinable<T[K]> }
  : T | undefined

type DeepUndefinableNonUndefined<T> = Exclude<DeepUndefinable<T>, undefined>

// The cookies from context are in the shape {['cookie-name-here': 'value']},
// the cookie constants values reference the context by key
export const buildCookieTree = (initialData: CookieBranch) => {
  const recur = (data: CookieBranch) => {
    return Object.entries(data).reduce((acc, [key, val]) => {
      acc[key] = typeof val === 'string' ? initialData[val] : recur(val)
      return acc
    }, {} as CookieBranch)
  }

  return recur(constants.cookies) as DeepUndefinable<CookieTree> // :hear-no-evil-emoji
}
